type IconProps = React.ComponentProps<'svg'>

export function ArrowRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.25, 4.25)">
        <path
          d="M7.21973 0.21967C7.51262 -0.0732233 7.98738 -0.0732233 8.28027 0.21967L15.2803 7.21967C15.5731 7.51257 15.5732 7.98733 15.2803 8.28022L8.28027 15.2802C7.98739 15.5731 7.51261 15.5731 7.21973 15.2802C6.92684 14.9873 6.92686 14.5126 7.21973 14.2197L12.9395 8.49994H0.75C0.335805 8.49994 3.06649e-05 8.16413 0 7.74994C0 7.33573 0.335786 6.99994 0.75 6.99994H12.9395L7.21973 1.28022C6.92684 0.987333 6.92686 0.512565 7.21973 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
